/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EstimatedSellerNet
 */
export interface EstimatedSellerNet {
}

/**
 * Check if a given object implements the EstimatedSellerNet interface.
 */
export function instanceOfEstimatedSellerNet(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EstimatedSellerNetFromJSON(json: any): EstimatedSellerNet {
    return EstimatedSellerNetFromJSONTyped(json, false);
}

export function EstimatedSellerNetFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimatedSellerNet {
    return json;
}

export function EstimatedSellerNetToJSON(value?: EstimatedSellerNet | null): any {
    return value;
}

